import { setDashboardSettingsSagas } from './outgoing/sagas/desktop.setDashboardSettings.sagas';
import { draftDocumentsCountersSagas } from './outgoing/sagas/draft.counters.sagas';

export const documentsSagas = [
  // Draft Document(s)
  draftDocumentsCountersSagas,
  setDashboardSettingsSagas,
];
